export const PERMISSIONS = {
  auctionView: 'auctionView',
  manageAuction: 'manageAuction',
  listingBid: 'listingBid',
  listingView: 'listingView',
  sellerManageMembers: 'sellerManageMembers',
  acceptBid: 'acceptBid',
  rejectBid: 'rejectBid',
  signAgreement: 'signAgreement',
  liveBidding: 'livebidding'
};
